import React, { useEffect, useState } from 'react';
import { Icon, Input, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styles from './UploadDragAndDrop.module.scss';
import FilesTable from './UploadFilesTable/FilesTable';

type Props = {
  modalErrorMessage: string | null;
  setFilesToSubmit: (filesToSubmit: File[] | null | undefined) => void;
};

function UploadDragAndDrop({ modalErrorMessage, setFilesToSubmit }: Props) {
  const [files, setFiles] = useState<File[] | null | undefined>();
  const { t } = useTranslation();

  const addDragDropEventListener = (
    dragAndDropArea: HTMLElement,
    type: string,
    alphaValue: number
  ) => {
    dragAndDropArea.addEventListener(type, () => {
      dragAndDropArea.setAttribute('style', `background-color: rgba(0,0,0,${alphaValue})`);
    });
  };

  useEffect(() => {
    const dragAndDropArea = document.getElementById('fileWrapperUploader');
    if (dragAndDropArea) {
      addDragDropEventListener(dragAndDropArea, 'dragover', 0.1);
      addDragDropEventListener(dragAndDropArea, 'dragleave', 0);
      addDragDropEventListener(dragAndDropArea, 'drop', 0);
    }
  }, []);

  const onFilesChange = (event: any) => {
    let fileList: Array<File> = [];
    if (event.currentTarget.files) {
      fileList = Array.from(event.currentTarget.files);
    }
    if (files) {
      fileList = files.concat(fileList);
    }
    setFiles(fileList);
    setFilesToSubmit(fileList);
  };

  const onDelete = (index: number) => {
    files?.splice(index, 1);
    setFiles(files);
    setFilesToSubmit(files);
  };

  return (
    <div>
      <div className={styles.fileWrapperUploader} id="fileWrapperUploader">
        <label htmlFor="name">
          <div>
            <Icon link name="upload" size="large" />
          </div>
          <div>{t('upload.file.drag.and.drop')}</div>
        </label>
        <Input
          fluid
          id="uploadFiles"
          name="files"
          type="file"
          multiple
          onChange={event => onFilesChange(event)}
        />
      </div>
      {modalErrorMessage && (
        <Message negative>
          <Message.Header>{t('error.uploading.fileset')}</Message.Header>
          <p>{modalErrorMessage}</p>
        </Message>
      )}
      {files && <FilesTable files={files} onDelete={onDelete} />}
    </div>
  );
}

export default UploadDragAndDrop;
